import * as React from 'react';
import {AXSBlock} from '@axs/axs-ui';
import styled from 'styled-components';
import { Link } from "react-router-dom";

const FooterElement = styled.footer`
    font-size: 14px;
    color: #aaaaaa;
    padding: 40px;
    background-color: #f6f6f6;
    
    a {
        color: #929292
    }
`;

const FooterTitle = styled(AXSBlock)`
    font-weight: bold;
`;

const LayoutWrapper = styled(AXSBlock)`
    max-width: 1200px;
    margin: 0 auto;
    padding: 15px;
`;


const LinkElement = styled(Link)`
    display: inline-block;
`;

const Footer = () => (
    <FooterElement>
        <LayoutWrapper>
            <FooterTitle> Our Guarantee </FooterTitle>
            <div> With Veritix, every ticket for every event is backed by our 100% buyer guarantee. That means you’ll always receive a valid and authentic
                ticket in time for your event, or your money back. <LinkElement to={"/terms"}> Learn More </LinkElement>
            </div>
        </LayoutWrapper>
    </FooterElement>
)
export default Footer;



// WEBPACK FOOTER //
// ./src/common/components/Footer/Footer.tsx